import React from "react";

/**
 * Global water-surface background and SVG ripple filter.
 * Rendered once at the App root; sits fixed behind all content.
 */
const WaterBackground = () => {
  return (
    <>
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="water-ripple">
            <feTurbulence type="fractalNoise" baseFrequency="0.012 0.04" numOctaves="2" seed="3">
              <animate attributeName="baseFrequency" dur="22s" values="0.012 0.04;0.018 0.06;0.012 0.04" repeatCount="indefinite" />
            </feTurbulence>
            <feDisplacementMap in="SourceGraphic" scale="6" />
          </filter>
          <filter id="caustics-noise">
            <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" seed="7" />
            <feColorMatrix values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.18 0" />
          </filter>
        </defs>
      </svg>

      <div className="water-bg" aria-hidden="true">
        <div className="water-bg__base" />
        <div className="water-bg__caustics" />
        <div className="water-bg__shimmer" />
        <div className="water-bg__noise" />
        <div className="water-bg__vignette" />
      </div>
    </>
  );
};

export default WaterBackground;
